import { Row, Col, Nav } from "reactstrap";

const Footer = () => {
  return (
    <footer className="footer" style={{background: "#d2c774"}}>
      <Row className="align-items-center justify-content-xl-between">
        <Col xl="6">
          <div className="copyright text-center text-xl-left " style={{color: "#000"}}>
            © {new Date().getFullYear()}{" "}
            <a
            style={{color:"#000"}}
              className="font-weight-bold ml-1"
              href="https://fempulse.com/home/"
              rel="noopener noreferrer"
              target="_blank"
            >
              Telepathy Lamps – India’s 1st Long Distance Lamps
            </a>
          </div>
        </Col>

        <Col xl="6">
          <Nav className="nav-footer justify-content-center justify-content-xl-end">
          </Nav>
        </Col>
      </Row>
    </footer>
  );
};

export default Footer;
